import {
  ALERT_SIGNAL_TYPE,
  ALERT_STATUS,
} from '~/lib/constants/providerDashboard.constants';
import { ProviderAlert } from '~/lib/types/providerDashboard';
import { getDiffInWeeks } from '~/lib/util/patient.util';

const DATE_FORMAT = 'yyyy-MM-dd';

const HEADLINE_BY_SIGNAL_TYPE: Record<string, (patientName: string) => string> =
  {
    [ALERT_SIGNAL_TYPE.WEIGHT_OFF_TRACK]: (patientName) =>
      `${patientName} is off track for reaching weight goal`,
  };

export const getAlertHeadline = (
  { title, signalType }: ProviderAlert,
  patientName: string,
): string =>
  title ||
  HEADLINE_BY_SIGNAL_TYPE[signalType]?.(patientName) ||
  `${patientName} needs attention`;

export const isUnreadAlert = (alert: ProviderAlert): boolean =>
  alert.status === ALERT_STATUS.ACTIVE;

export const isOpenAlert = (alert: ProviderAlert): boolean =>
  alert.status === ALERT_STATUS.ACTIVE ||
  alert.status === ALERT_STATUS.ACKNOWLEDGED;

export const getAlertMetaLabel = ({
  admitDate,
  diagnosis,
  treatmentModality,
}: ProviderAlert): string => {
  const weekAtEquip = admitDate
    ? getDiffInWeeks(admitDate, undefined, DATE_FORMAT)
    : -1;
  const diagnosisLabel =
    diagnosis && treatmentModality
      ? `${diagnosis} (${treatmentModality})`
      : diagnosis || treatmentModality || '';
  return [weekAtEquip > 0 ? `Week ${weekAtEquip}` : '', diagnosisLabel]
    .filter(Boolean)
    .join(' · ');
};
